import { AppConfigModel } from '@b2c/hooks';

export const AppConfig: AppConfigModel = {
  brandName: 'AIGoHotel',
  fixedSetting: true,
  defaultCurrency: 'CNY',
  defaultNationality: 'CN',
  defaultLocale: 'zh-CN',
  customerService: {
    email: 'cs@aigohotel.com',
    tels: [
      {
        code: 'CN',
        number: '+86-???????',
      },
    ],
  },
};
